import React, { useState, useEffect } from 'react'
import { Button } from '@material-ui/core'
import { AddCircle as AddIcon } from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import CardView from './CardView'
import AddCardDialog from './AddCreditCardDialog'

const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  addCardButton: {
    marginTop: theme.spacing.unit,
    width: 200
  },
  addIcon: {
    marginRight: theme.spacing.unit / 2
  }
})

const AddCreditCard = ({ classes, cards, isLoading, fetchCreditCards, addCreditCard }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (cards === undefined && !isLoading) {
      fetchCreditCards()
    }
  })

  // stores the state of the AddCreditCard dialog
  const [addCardDialogState, setAddCardDialogState] = useState(false)

  return (
    <div className={classes.container}>

      {
        cards && cards.map(({ id, cardNumber, cardHolderName, expirationDate }) => (
          <CardView
            key={id}
            cardNumber={cardNumber}
            name={cardHolderName}
            expiration={expirationDate}
          />
        ))
      }

      <Button className={classes.addCardButton} variant='contained' color='primary'
        onClick={() => setAddCardDialogState(true)}>
        <AddIcon className={classes.addIcon} fontSize='small'/>
        {t('Cabinet:add credit card')}
      </Button>

      <AddCardDialog open={addCardDialogState}
        onClose={() => setAddCardDialogState(false)}
        onSubmit={addCreditCard} />

    </div>
  )
}

export default withStyles(styles)(AddCreditCard)
